import extraLuggageIcon from "../../../../images/extra-luggage.png";
import extraSurfboardIcon from "../../../../images/extra-surfboard.png";
import extraBabySeatIcon from "../../../../images/extra-baby-seat.png";
import extraBabyBoosterIcon from "../../../../images/extra-baby-booster.png";

const EXTRAS_META = [
	{
		key: "luggage",
		label: "Extra Luggage",
		description: "1 Carry on and 1 Check in Luggage per person is included in Service. If you have any extra luggage please choose number of bags you would like to add",
		image: extraLuggageIcon,
		priceKey: "extra_luggage_price",
		maxKey: "extra_luggage_max",
	},
	{
		key: "surfboard",
		label: "Surfboard",
		description: "If you are travelling with Extra Large Item like Bike or Surfboard etc please add",
		image: extraSurfboardIcon,
		priceKey: "surfboard_price",
		maxKey: "surfboard_max",
	},
	{
		key: "babySeats",
		label: "Baby Seats",
		description: "If you are travelling with Child (0 months to 4 Years old)",
		image: extraBabySeatIcon,
		priceKey: "baby_seats_price",
		maxKey: "baby_seats_max",
	},
	{
		key: "babyBooster",
		label: "Baby Booster",
		description: "If you are travelling with Child (4 to 7 years old)",
		image: extraBabyBoosterIcon,
		priceKey: "baby_booster_price",
		maxKey: "baby_booster_max",
	},
];

export default EXTRAS_META;
